"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var helpers_1 = require("./helpers");
var consts_1 = require("./departments/consts");
var consts_2 = require("./users/consts");
var baseUrlByEnvironment = {
    production: 'http://customers-management.customers-management.svc/v1',
    staging: 'http://customers-management.customers-management.svc/v1',
    development: 'http://localhost:8085/v1',
};
var CustomerManagementClient = /** @class */ (function () {
    function CustomerManagementClient(_a) {
        var environment = _a.environment, baseUrl = _a.baseUrl;
        var resolvedBaseUrl = (environment && baseUrlByEnvironment[environment]) || baseUrl;
        if (!resolvedBaseUrl) {
            throw new Error('CustomerManagementClient requires either an environment or a baseUrl');
        }
        this.apiClient = axios_1.default.create({ baseURL: resolvedBaseUrl });
    }
    CustomerManagementClient.prototype.createUser = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var response, createdUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.post('/user', user)];
                    case 1:
                        response = (_a.sent());
                        createdUser = response.data.user;
                        return [2 /*return*/, createdUser];
                }
            });
        });
    };
    CustomerManagementClient.prototype.updateUser = function (userId, updates, customerType, governmentType, shouldCalculateUseCases) {
        return __awaiter(this, void 0, void 0, function () {
            var response, updatedUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.put("/user/".concat(userId), updates, {
                            params: { customerType: customerType, governmentType: governmentType, shouldCalculateUseCases: shouldCalculateUseCases },
                        })];
                    case 1:
                        response = (_a.sent());
                        updatedUser = response.data.user;
                        return [2 /*return*/, updatedUser];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getUserById = function (userId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // userId is required, but we're checking it has a value for backward compatibility with non-typed code
                        if (!userId) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.apiClient.get("/user/".concat(userId), {
                                params: options,
                            })];
                    case 1:
                        response = (_a.sent());
                        if (response.status === 404) {
                            return [2 /*return*/, null];
                        }
                        user = response.data.user;
                        return [2 /*return*/, user];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getUsers = function (filters, options) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, response, users;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = __assign(__assign({}, (0, helpers_1.pick)(options !== null && options !== void 0 ? options : {}, ['limit', 'skip'])), { filters: filters });
                        if (options === null || options === void 0 ? void 0 : options.select) {
                            payload.select = options.select;
                        }
                        return [4 /*yield*/, this.apiClient.post("/user/search", payload)];
                    case 1:
                        response = (_a.sent());
                        users = response.data.users;
                        return [2 /*return*/, users];
                }
            });
        });
    };
    CustomerManagementClient.prototype.countUsers = function (filters) {
        return __awaiter(this, void 0, void 0, function () {
            var response, count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.post("/user/search/count", filters)];
                    case 1:
                        response = (_a.sent());
                        count = response.data.count;
                        return [2 /*return*/, count];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getUserResponsibilityOptions = function () {
        return consts_2.USER_RESPONSIBILITY_DEFINITIONS.map(function (option) { return ({
            key: option.responsibility,
            label: (0, helpers_1.getOptionDisplayName)(option.responsibility, option.displayName, 'en'),
        }); }).sort(helpers_1.optionsSortCompare);
    };
    CustomerManagementClient.prototype.getUserUseCaseOptions = function () {
        return consts_2.USER_USE_CASES_DEFINITIONS.map(function (option) { return ({
            key: option.useCase,
            label: (0, helpers_1.getOptionDisplayName)(option.useCase, option.displayName, 'en'),
        }); }).sort(helpers_1.optionsSortCompare);
    };
    CustomerManagementClient.prototype.createDepartment = function (department, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, createdDepartment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.post('/department', department, {
                            params: options,
                        })];
                    case 1:
                        response = (_a.sent());
                        createdDepartment = response.data.department;
                        return [2 /*return*/, createdDepartment];
                }
            });
        });
    };
    CustomerManagementClient.prototype.updateDepartment = function (departmentId, updates, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, updatedDepartment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.put("/department/".concat(departmentId), updates, {
                            params: options,
                        })];
                    case 1:
                        response = (_a.sent());
                        updatedDepartment = response.data.department;
                        return [2 /*return*/, updatedDepartment];
                }
            });
        });
    };
    CustomerManagementClient.prototype.deleteDepartment = function (departmentId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.delete("/department/".concat(departmentId))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getDepartments = function (customer) {
        return __awaiter(this, void 0, void 0, function () {
            var response, departments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.get("/department", {
                            params: { customer: customer },
                        })];
                    case 1:
                        response = (_a.sent());
                        departments = response.data.departments;
                        return [2 /*return*/, departments];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getDepartmentById = function (departmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, department;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!departmentId) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.apiClient.get("/department/".concat(departmentId))];
                    case 1:
                        response = (_a.sent());
                        department = response.data.department;
                        return [2 /*return*/, department];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getDepartmentResponsibilityOptions = function (customerType) {
        return consts_1.DEPARTMENT_RESPONSIBILITY_DEFINITIONS.filter(function (option) {
            return option.availableForCustomerTypes.includes(customerType);
        })
            .map(function (option) { return ({
            key: option.responsibility,
            label: (0, helpers_1.getOptionDisplayName)(option.responsibility, option.displayName, 'en'),
        }); })
            .sort(helpers_1.optionsSortCompare);
    };
    CustomerManagementClient.prototype.getCustomerProducts = function (customer) {
        return __awaiter(this, void 0, void 0, function () {
            var response, customerProducts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.get("/customer/".concat(customer, "/product"))];
                    case 1:
                        response = (_a.sent());
                        customerProducts = response.data.customerProducts;
                        return [2 /*return*/, customerProducts];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getCustomerProductContracts = function (customer) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.get("/customer/".concat(customer, "/product/contract"))];
                    case 1:
                        response = (_a.sent());
                        return [2 /*return*/, response.data.customerProductContracts];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getCustomerProductsSummary = function (customer) {
        return __awaiter(this, void 0, void 0, function () {
            var response, summary;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.get("/customer/".concat(customer, "/product/summary"))];
                    case 1:
                        response = (_a.sent());
                        summary = response.data.summary;
                        return [2 /*return*/, summary];
                }
            });
        });
    };
    CustomerManagementClient.prototype.activateCustomerProduct = function (customer, customerProduct) {
        return __awaiter(this, void 0, void 0, function () {
            var product, customProductDetails, response, createdCustomerProduct;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        product = customerProduct.product, customProductDetails = __rest(customerProduct, ["product"]);
                        return [4 /*yield*/, this.apiClient.put("/customer/".concat(customer, "/product/").concat(product), customProductDetails)];
                    case 1:
                        response = (_a.sent());
                        createdCustomerProduct = response.data.customerProduct;
                        return [2 /*return*/, createdCustomerProduct];
                }
            });
        });
    };
    CustomerManagementClient.prototype.deactivateCustomerProduct = function (customer, product) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.delete("/customer/".concat(customer, "/product/").concat(product))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerManagementClient.prototype.activateUserProduct = function (user, product) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.put("/user/".concat(user, "/product/").concat(product))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerManagementClient.prototype.deactivateUserProduct = function (user, product) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.delete("/user/".concat(user, "/product/").concat(product))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerManagementClient.prototype.syncCustomerUsers = function (customer, services) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.post("/customer/".concat(customer, "/syncUsers"), { services: services })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerManagementClient.prototype.createPredefinedDepartments = function (customerId, customerType, locale) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.post("/department/predefined", {
                            customerId: customerId,
                            customerType: customerType,
                            locale: locale,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerManagementClient.prototype.getOrganizationalRoleDefaultFields = function (organizationalRole, customerType, customerId, governmentType) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.get('/user/organizationalRoleDefaultFields', {
                            params: { organizationalRole: organizationalRole, customerType: customerType, customerId: customerId, governmentType: governmentType },
                        })];
                    case 1:
                        response = (_a.sent());
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return CustomerManagementClient;
}());
exports.default = CustomerManagementClient;
